export default {
  headers: {
    // Common headers
    result: "Резултат",
    results: "Резултати",
    current: "Текущ",
    examination: "Изследване",
    test: "Тест",
    flag: "Флаг",
    flagText: "Флаг",
    flags: "Флагове",
    refRange: "Реф. граници",
    units: "Единици",
    resultTime: "Дата / Час",
    history: "История",
    actions: "Действия",
    visit_id: "Визита",
    barcode: "Баркод",
    total_results: "Резултати",
    instrument: "Апарат",
    disk_rack: "Рафт/Статив",
    position: "Позиция",
    sample_number: "№ на проба",
    sample_type: "Тип проба",
    sets_count: "Серии",
    pending_results: "Чакащи",
    approved_results: "Одобрени",
    sample_code: "Код",
    collection_time: "Взета на",
    sample_category: "Категория",
    resultsCount: "Бр. резултати",
  },

  no_data: "Няма налични данни",

  // Table toolbar
  toolbar: {
    refresh: "Обнови",
    pdf: "Изтегли PDF",
    pdfAction: "Изтегляне",
    email: "Изпрати по имейл",
    emailAction: "Изпращане",
    moreActions: "Още действия",
  },
};
